module.exports = __webpack_public_path__ + "static/media/blazej-ios.d34ca6b9.png";